import { ThemeProvider } from "@sunday/component";
import { useTranslation } from "next-i18next";
import { ICTH_THEME } from "src/components/Common/ICTHLayout/constants";
import defaultTermsContent from "../../../../public/static/locales/en/terms-and-conditions.json";
import {
  TermsArticle,
  TermsBodyText,
  TermsContent,
  TermsContentContainer,
  TermsHeading,
  TermsPageContainer,
  TermsParagraph,
  TermsSectionTitle,
  TermsSpacer,
  TermsTitle,
} from "./TermsAndConditions.style";

type TermsBlock =
  | {
      type: "heading" | "paragraph";
      text: string;
    }
  | {
      type: "spacer";
    };

const TermsAndConditions = (): JSX.Element => {
  const { i18n, t } = useTranslation("terms-and-conditions");
  const translatedBlocks = t("blocks", { returnObjects: true });
  const blocks = Array.isArray(translatedBlocks)
    ? (translatedBlocks as TermsBlock[])
    : (defaultTermsContent.blocks as TermsBlock[]);
  const locale = i18n.language === "th" ? "th" : "en";

  return (
    <ThemeProvider theme={ICTH_THEME}>
      <TermsPageContainer>
        <TermsContentContainer>
          <TermsContent>
            <TermsTitle lang={locale}>
              {t("title", { defaultValue: defaultTermsContent.title })}
            </TermsTitle>
            <TermsArticle>
              {blocks.map((block, index) => {
                const blockKey = `${block.type}-${index}`;

                if (block.type === "spacer") {
                  return <TermsSpacer key={blockKey} aria-hidden="true" />;
                }

                if (block.type === "heading") {
                  return (
                    <TermsHeading key={blockKey}>
                      <TermsSectionTitle>{block.text}</TermsSectionTitle>
                    </TermsHeading>
                  );
                }

                return (
                  <TermsParagraph key={blockKey}>
                    <TermsBodyText>{block.text}</TermsBodyText>
                  </TermsParagraph>
                );
              })}
            </TermsArticle>
          </TermsContent>
        </TermsContentContainer>
      </TermsPageContainer>
    </ThemeProvider>
  );
};

export default TermsAndConditions;
